import { get } from "lodash";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { Col, Row } from "reactstrap";
import { IApplication } from "src/store/models/application.model";
import { fetchBrokerApps } from "src/store/reducers/brokerApps";
import { Container } from "../../../components/Container/Container";
import DisTable from "../../../components/TableV2/Table";
import Toast from "../../../components/Toast/Toast";
import * as S from "../../../constants/StringConstants";
import { brokersApplicationsPageColumns } from "../../Applications/constants";
import "./BrokerApps.scss";

export interface BrokerAppsProps {}

const BrokerApps = (props: BrokerAppsProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const { id: brokerID } = useParams<{ id: string }>();

  return (
    <>
      <main className="broker-tab__wrap">
        <section className="broker-tab__container">
          <Container>
            <div className="broker-tab__form-wrap">
              <Row>
                <Col sm="9" className="doc-tab__title">
                  <h1 className="form-title">{S.BRO_APPS_TITLE}</h1>
                </Col>
              </Row>

              <Row>
                <Col className="doc-tab__table-override">
                  <DisTable<IApplication>
                    columns={brokersApplicationsPageColumns}
                    onRowClick={row => {
                      window.open(`/applications/${row.id}`);
                    }}
                    onUpdate={async ({ page, rows, sort, query }) => {
                      setLoading(true);
                      const result: any = await dispatch(fetchBrokerApps({ brokerID, page, rows, sort, query }));
                      setLoading(false);
                      return {
                        total: get(result, "value.data.totalRows") as number,
                        data: get(result, "value.data.items") as IApplication[],
                      };
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      </main>

      <Toast open={loading} message={S.LOADING} onClose={() => {}} />
    </>
  );
};

export default BrokerApps;
